export default __webpack_public_path__ + "static/media/photographer.3b8ec9fd.png";